import { SCOPE_ZONE_PARENT_HIERARCHY } from "../../constants/apis";
import { replaceMultiple } from "../../utilities/helpers";

export const fetchScopeNodeHierarchy =
  (zoneNodeType, nodeId) =>
  (dispatch, getState, { apiAuth }) => {
    const url = replaceMultiple(SCOPE_ZONE_PARENT_HIERARCHY, {
      "{NODE_TYPE}": zoneNodeType,
      "{NODE_ID}": nodeId,
    });

    return apiAuth
      .get(url)
      .then((result) => result)
      .catch((err) => {
        throw err;
      });
  };
